<template>
  <div>
    <tables :config="config()" />
  </div>
</template>

<script>
  export default {
    data () {
      return {
        
      }
    },
    components: {
      tables: () => import(/* webpackPrefetch: true */ '@/components/basic/table.vue')
    },
    watch: {

    },
    computed: {
      
    },
    mounted () {
      
    },
    methods: {
      config () {
        return {
          // CONFIG PARSING API
          api: 'admin/audittrail',

          // SINGLE
          single: true,

          // CHECKBOX
          checkbox: false,

          // PADDING
          padding: 'py-0',

          // HEIGHT
          height: true,

          // CONFIG PARSING HEADER
          header: [
            {
              text: '#No',
              width: '75px',
              value: 'index',
              sortable: false,
              freeze: true,
              hide: false,
              align: 'center'
            },
            {
              text: 'Kode',
              width: '200px',
              value: 'code',
              sortable: false,
              freeze: false,
              hide: false
            },
            {
              text: 'Unit',
              width: '400px',
              value: 'unit_name',
              sortable: false,
              freeze: false,
              hide: false
            },
            {
              text: 'Nama Lengkap',
              width: '400px',
              value: 'name',
              sortable: false,
              freeze: false,
              hide: false
            },
            {
              text: 'Username',
              width: '300px',
              value: 'username',
              sortable: false,
              freeze: false,
              hide: false
            },
            {
              text: 'Aksi',
              width: '200px',
              value: 'event',
              sortable: false,
              freeze: false,
              hide: false
            },
            {
              text: 'Url',
              width: '200px',
              value: 'url',
              sortable: false,
              freeze: false,
              hide: false
            },
            {
              text: 'Query',
              width: '1000px',
              value: 'query',
              sortable: false,
              freeze: false,
              hide: false
            },
            {
              text: 'IP Address',
              width: '200px',
              value: 'ip_address',
              sortable: false,
              freeze: false,
              hide: false
            },
            {
              text: 'User Agent',
              width: '500px',
              value: 'user_agent',
              sortable: false,
              freeze: false,
              hide: false
            },
            {
              text: 'Tanggal & Waktu',
              width: '200px',
              value: 'create_datetime',
              sortable: false,
              freeze: false,
              hide: false,
              format: 'datetime'
            }
          ],

          // CONFIG PARSING FILTER
          filter: [],

          // CONFIG PARSING FORM
          form: [],

          // PREFIX KEY
          prefix: '',

          // CONFIG PARSING ACTION
          action: {
            tab: {
              button: false,
              api: [],
              field: ''
            },
            filter: {
              button: false,
              api: ''
            },
            add: {
              button: false,
              api: '',
              window: false,
              href: ''
            },
            edit: {
              button: false,
              api: '',
              window: false,
              href: ''
            },
            delete: {
              button: false,
              api: ''
            },
            detail: {
              button: false,
              api: '',
              text: ''
            },
            attachment: {
              button: false,
              api: ''
            },
            active: {
              button: false,
              api: ''
            },
            deactive: {
              button: false,
              api: ''
            },
            reject: {
              button: false,
              api: ''
            },
            approve: {
              button: false,
              api: ''
            },
            reset: {
              button: false,
              api: ''
            },
            print: {
              button: false,
              api: ''
            },
            freeze: {
              button: true,
              api: ''
            },
            hide: {
              button: true,
              api: ''
            }
          }
        }
      }
    }
  }
</script>